<template>
  <div id="app">
    <router-view v-if="showPage" />
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      showPage: false,
    };
  },
  mounted() {
    let time = new Date().getTime();
    this.$loadScript.loadScript(
      process.env.VUE_APP_ssoSDK + "?time=" + time,
      () => {
        if (this.$urlData.appid) {
          oauthSDK.init({
            appid: this.$urlData.appid,
            bsKey: this.$urlData.bsKey || "",
            clientType: this.$urlData.clientType,
            redirectURL: this.$urlData.redirectURL,
            logoutURL: this.$urlData.logoutURL,
          });
          oauthSDK
            .getTheme()
            .then((theme) => {
              this.Th.changeTheme(theme.theme.themeColor);
              this.$store.commit("upDatassoSDK", true);
              this.$store.commit("saveAppTheme", theme);
              let data = {
                google: theme.theme.googleClientId ? 1 : 0,
                facebook: theme.theme.facebookAppId ? 1 : 0,
                appid: this.$urlData.appid,
                bsKey: this.$urlData.bsKey || "",
                clientType: this.$urlData.clientType,
                redirectURL: this.$urlData.redirectURL,
                logoutURL: this.$urlData.logoutURL,
              };
              if (this.$isNative) {
                let sdkInfo = JSON.parse(native_sup.getSdkInfo());
                for (
                  let index = 0;
                  index < sdkInfo.supportThirdTypes.length;
                  index++
                ) {
                  data[sdkInfo.supportThirdTypes[index]] = 1;
                }
              }
              this.$store.commit("saveSdkInfo", data);
              this.showPage = true;
            })
            .catch((err) => {
              console.log(err);
              // this.defalutToast(err.message);
              // this.$alert(
              //   this.language("err.appErrText"),
              //   this.language("err.title"),
              //   {
              //     showClose: false,
              //     showConfirmButton: true,
              //   },
              // );
              this.$confirm(
                this.language("err.appErrText"),
                this.language("err.title"),
                {
                  confirmButtonText:this.language("err.tipsText1"),
                  type: "warning",
                  showCancelButton: false,
                }
              )
                .then(() => {
                  window.location.replace(process.env.VUE_APP_memeberHttps);
                })
                .catch(() => {});
            });
        }
      }
    );
  },
};
</script>
<style>
#app {
  width: 100%;
  background: #f6f6f6;
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
  /* font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif; */
}
</style>
